// Uses Choices.js pattern like app/packs/custom/chart.js

// Controls wiring for Episode Release Performance Comparison
// Wires the range <select> and the episodes multi-select (Tom Select)
// Emits a combined payload to onChange: { range, episodeIds }

export function wireEpisodeComparisonControls(rootEl, onChange) {
  const root = rootEl || document;
  const rangeEl = root.querySelector('#episode-comparison-range');
  const rangeButtons = Array.from(root.querySelectorAll('.epRangeButton'));
  let currentRange = '7d';
  const selectEl = root.querySelector('#multiple-select');
  let ts = null;

  function getRange() {
    if (rangeButtons && rangeButtons.length) return currentRange;
    return (rangeEl && rangeEl.value) ? rangeEl.value : '7d';
  }

  function getEpisodeIds() {
    if (!selectEl) return [];
    return Array.from(selectEl.selectedOptions || []).map(o => o.value);
  }

  function emit() {
    if (typeof onChange === 'function') {
      onChange({ range: getRange(), episodeIds: getEpisodeIds() });
    }
  }

  // Initialize Tom Select on the multi-select (max 5)
  if (selectEl) {
    try {
      if (typeof Choices !== 'undefined') {
        ts = new Choices(selectEl, {
          removeItemButton: true,
          maxItemCount: 5,
          placeholderValue: 'Search for an episode here',
          shouldSort: false
        });
        // Support pre-selection via data attribute (e.g., data-preselect="1,2,3")
        const preselect = selectEl.dataset.preselect;
        if (preselect && ts) {
          const values = preselect.split(',').map(v => v.trim());
          ts.setChoiceByValue(values);
        }
      }
    } catch (_) { /* ignore */ }
    selectEl.addEventListener('change', emit);
  }

  if (rangeEl) rangeEl.addEventListener('change', () => { currentRange = rangeEl.value || '7d'; emit(); });

  if (rangeButtons && rangeButtons.length) {
    function setActive(target) {
      rangeButtons.forEach(btn => btn.classList.remove('bg-quill-100'));
      try { target.classList.add('bg-quill-100'); } catch (_) {}
    }
    setActive(rangeButtons[0]);
    currentRange = rangeButtons[0]?.dataset?.epRange || '7d';
    rangeButtons.forEach(btn => {
      btn.addEventListener('click', () => {
        currentRange = btn?.dataset?.epRange || '7d';
        setActive(btn);
        emit();
      });
    });
  }

  return {
    getRange,
    getEpisodeIds,
    destroy() {
      try { ts && ts.destroy && ts.destroy(); } catch (_) {}
      if (selectEl) { try { selectEl.removeEventListener('change', emit); } catch (_) {} }
      if (rangeEl) { try { rangeEl.removeEventListener('change', emit); } catch (_) {} }
    }
  };
}
